export const apiEndPoints = {
  verify: "/user/verify",
  details: "/user/details",
  getRoom: "/room",
  roomJoin: "/room/join",
  roomLeave: "/room/leave",
};

